<template>
  <app-graph :traces="traces" :default-range-size="defaultRangeSize" :title="selectedTrialName" />
</template>

<script>
import _ from 'lodash'
import AppGraph from '@/components/common/AppGraph'
import {
  getBaseTrace,
  getXAxis,
  GraphTypes,
  MONTHS_TO_DISPLAY,
  TraceTypes
} from '@/helpers/graph-helper'
import trialSummaryService from '@/services/trial-summary-service'
import { vuetifyColors } from '@/assets/vuetify-config'
import { summaryValues } from '@/helpers/summary-value-helper'

export default {
  components: {
    AppGraph
  },
  props: {
    editedSite: { type: Object, default: null },
    orgTrialExternalId: { type: String, default: null },
    trialExternalId: { type: String, default: null },
    selectedTrialName: { type: String, default: null },
    trialId: { type: String, default: null }
  },
  data() {
    return {
      loading: true,
      trends: []
    }
  },
  computed: {
    defaultRangeSize() {
      return MONTHS_TO_DISPLAY
    },
    sortedTrends() {
      return _.sortBy(this.trends, 'trendDate')
    },
    x() {
      return getXAxis(this.sortedTrends)
    },
    averageAwaitingReviewTrace() {
      return this.getTraceFromTrends(
        this.sortedTrends,
        TraceTypes.AVG_DAYS_AWAITING_REVIEW,
        'Average Days "Awaiting Review"',
        GraphTypes.STACKED_AREA,
        vuetifyColors.mediumTwo
      )
    },
    averageInReviewTrace() {
      return this.getTraceFromTrends(
        this.sortedTrends,
        TraceTypes.AVG_DAYS_IN_REVIEW,
        'Average Days "In Review"',
        GraphTypes.STACKED_AREA,
        vuetifyColors.primary
      )
    },
    traces() {
      return [this.averageAwaitingReviewTrace, this.averageInReviewTrace]
    },
    trendRequestParams() {
      return {
        trialId: this.trialId,
        cumulative: false,
        summaryValues: [
          summaryValues.TREND_DATE,
          summaryValues.AVERAGE_DAYS_AWAITING_REVIEW,
          summaryValues.AVERAGE_DAYS_IN_REVIEW,
          summaryValues.TRIAL_ID,
          summaryValues.TRIAL_FRIENDLY_NAME,
          summaryValues.ORGANIZATION_NAME,
          summaryValues.ORGANIZATION_EXTERNAL_ID
        ]
      }
    }
  },
  watch: {
    trendRequestParams() {
      this.fetchTrends()
    }
  },
  created() {
    this.fetchTrends()
  },
  methods: {
    async fetchTrends() {
      this.loading = true
      try {
        let { data } = await trialSummaryService.listTrialSummaryTrends(this.trendRequestParams)
        this.trends = data
      } finally {
        this.loading = false
      }
    },
    getTraceFromTrends(trends, status, name, graphType, color) {
      return _.merge({ mode: 'lines+markers' }, getBaseTrace(graphType, color), {
        x: this.x,
        y: _.map(trends, trend => trend[status]),
        name: name
      })
    }
  }
}
</script>
